import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {CustomerRoutes, Routes} from '@/config/routes';

const DoubleCheckIcon = getImageAssetUrl('icons/icon-double-check.svg');
const LocationIcon = getImageAssetUrl('icons/icon-location.svg');
const UserHeartIcon = getImageAssetUrl('icons/icon-user-heart.svg');

export function UserInfoMenu() {
    return (
        <div className="mt-2.5 grid grid-cols-3 gap-1 text-[12px]">
            <Link href={`${Routes.customer}/${CustomerRoutes.info}`}>
                <div className="flex h-full w-full flex-col items-center justify-start rounded-xl bg-white px-1 py-[10px]">
                    <Image src={UserHeartIcon} alt="Icon User Heart" width={20} height={20} />
                    <p className="mt-1 text-center text-primary">Thông tin tài khoản</p>
                </div>
            </Link>
            <Link href={`${Routes.customer}/${CustomerRoutes.address}`}>
                <div className="flex h-full w-full flex-col items-center justify-start rounded-xl bg-white px-1 py-[10px]">
                    <Image src={LocationIcon} alt="Icon Location" width={20} height={20} />
                    <p className="mt-1 text-center text-primary">Sổ</p>
                    <p className="text-center text-primary">địa chỉ</p>
                </div>
            </Link>
            <Link href={`${Routes.customer}/${CustomerRoutes.recentlyViewed}`}>
                <div className="flex h-full w-full flex-col items-center justify-start rounded-xl bg-white px-1 py-[10px]">
                    <Image src={DoubleCheckIcon} alt="Icon Double Check" width={20} height={20} />
                    <p className="mt-1 text-center text-primary">Sản phẩm đã xem</p>
                </div>
            </Link>
        </div>
    );
}
